"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitialState = exports.NOOPModal = void 0;
const NOOPModal = () => null;
exports.NOOPModal = NOOPModal;
exports.InitialState = {
    modal: exports.NOOPModal,
};
